import { render, staticRenderFns } from "./productOrderBoxes.vue?vue&type=template&id=325f58f0&"
import script from "./productOrderBoxes.vue?vue&type=script&lang=js&"
export * from "./productOrderBoxes.vue?vue&type=script&lang=js&"
import style0 from "./productOrderBoxes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports